var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "down 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: 16
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.99981 12.0002C7.99905 11.8686 8.02428 11.7381 8.07404 11.6163C8.12381 11.4944 8.19713 11.3836 8.28981 11.2902L14.2898 5.29019C14.4781 5.10188 14.7335 4.99609 14.9998 4.99609C15.2661 4.99609 15.5215 5.10188 15.7098 5.29019C15.8981 5.47849 16.0039 5.73388 16.0039 6.00019C16.0039 6.26649 15.8981 6.52188 15.7098 6.71019L10.4098 12.0002L15.6998 17.2902C15.8636 17.4815 15.9492 17.7276 15.9395 17.9792C15.9298 18.2309 15.8255 18.4697 15.6474 18.6477C15.4693 18.8258 15.2305 18.9302 14.9789 18.9399C14.7272 18.9496 14.4811 18.864 14.2898 18.7002L8.28981 12.7002C8.10507 12.5139 8.00092 12.2625 7.99981 12.0002Z",
    fill: "#474747"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackChevron);
export default __webpack_public_path__ + "static/media/back-chevron.e38afe706579bc5f86400608be2cfeaf.svg";
export { ForwardRef as ReactComponent };